import { Card, Flex, Loader, ScrollArea, SimpleGrid, Text, Title } from '@mantine/core';
import { Link } from 'react-router';
import { useCalculators } from '../../hooks/use-calculators';
import { docSlug, versionDisplayName } from '../../versions/versions';

function CalculatorChooser({ version }: { version: string }) {
  const { loading, error, calculators } = useCalculators(version);

  return (
    <Flex h="calc(100vh - 120px - 32px)">
      <ScrollArea scrollbars="y" flex={1} miw={0}>
        <div className="api-docs container">
          <Title order={1} mb="md">
            REST API Reference
          </Title>
          <p>
            Interactive documentation for the Carbon Calculator API. Choose a calculator to view its parameters and try
            requests from this page.
          </p>
          <p>
            Currently viewing version:{' '}
            <Text span fw={600}>
              {versionDisplayName(version)}
            </Text>
          </p>

          <Title order={2} mb="md">
            Calculators
          </Title>

          {loading ? (
            <Flex justify="center" align="center" w="100%" h="200px">
              <Loader size="lg" />
              <Text ml="md">Loading calculators...</Text>
            </Flex>
          ) : error ? (
            <Text c="red">{error}</Text>
          ) : (
            <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="md">
              {(calculators ?? []).map((calculator) => (
                <Card
                  key={calculator}
                  withBorder
                  bg="var(--color-bg-secondary)"
                  component={Link}
                  to={`/api/${docSlug(version)}/api-reference/${calculator}`}
                  style={{ textDecoration: 'none', color: 'inherit' }}
                >
                  <Text fw={600}>{calculator}</Text>
                </Card>
              ))}
            </SimpleGrid>
          )}
        </div>
      </ScrollArea>
    </Flex>
  );
}

export default CalculatorChooser;
